<template>
  <div v-if="isRatingNotZero" class="flex items-center">
    <RevRating :score="score" size="small" />
    <span class="text-static-default-hi caption ml-4"> ({{ count }}) </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevRating } from '@ds/components/Rating'

const props = withDefaults(
  defineProps<{
    score?: number
    count?: number
  }>(),
  { score: 0, count: 0 },
)

const isRatingNotZero = computed(() => {
  return props.score > 0 && props.count > 0
})
</script>

<style scoped>
:deep(div > span) {
  text-indent: -10000px;
  margin: 0;
}

:deep([role='presentation']) {
  display: flex;
  align-items: center;
}

:deep(svg) {
  height: 12px;
  width: 12px;
}
</style>
